var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.company.active_subscription)?_c('v-btn',{attrs:{"to":{ name: 'subscription' },"color":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('texts.buySubscription'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }